import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { IBuildingCard } from 'shared/types/buildingCard';
import type { IBuildingOffersState, IOffersFilters, IOffersSort } from 'shared/types/buildingOffers';
import { fetchBuildingOffers } from 'shared/thunks/buildingOffers';
import { getInitialOffersFilters } from 'shared/utils/buildingOffers';

/** Начальное состояние строится на сервере из карточки — фильтры и вкладки есть уже в SSR */
export const getInitialBuildingOffersState = (card: IBuildingCard, subdomain: string): IBuildingOffersState => ({
  subdomain,
  filters: getInitialOffersFilters(card.offerCategories),
  sort: null,
  status: 'idle',
  data: null,
  selectedIndex: 0,
  requestId: null,
});

const buildingOffersSlice = createSlice({
  initialState: {} as IBuildingOffersState,
  name: 'buildingOffers',
  reducers: {
    /** Любая смена фильтра, вкладки или якоря сбрасывает сортировку, как в монолите */
    setOffersFilters(state, { payload }: PayloadAction<IOffersFilters>) {
      state.filters = payload;
      state.sort = null;
    },
    setOffersSort(state, { payload }: PayloadAction<IOffersSort>) {
      state.sort = payload;
    },
    selectOffer(state, { payload }: PayloadAction<number>) {
      state.selectedIndex = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBuildingOffers.pending, (state, { meta }) => {
        state.status = 'loading';
        state.requestId = meta.requestId;
      })
      .addCase(fetchBuildingOffers.fulfilled, (state, { meta, payload }) => {
        if (meta.requestId === state.requestId) {
          state.status = 'success';
          state.data = payload;
          // Как в монолите: после загрузки открыто превью первой строки
          state.selectedIndex = 0;
        }
      })
      .addCase(fetchBuildingOffers.rejected, (state, { meta }) => {
        if (meta.requestId === state.requestId) {
          state.status = 'error';
        }
      });
  },
});

export const { setOffersFilters, setOffersSort, selectOffer } = buildingOffersSlice.actions;
export const { reducer: buildingOffersReducer } = buildingOffersSlice;
